<template>
  <div>
    <eBillingPortal-list></eBillingPortal-list>
  </div>
</template>

<script>

export default {
}
</script>


